import { render, staticRenderFns } from "./thirdBank.vue?vue&type=template&id=51cee389&scoped=true"
import script from "./thirdBank.vue?vue&type=script&lang=js"
export * from "./thirdBank.vue?vue&type=script&lang=js"
import style0 from "./thirdBank.vue?vue&type=style&index=0&id=51cee389&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cee389",
  null
  
)

export default component.exports